import React, { forwardRef } from "react";
import styles from "./MashlimDoctorResult.module.scss";
import { MashlimDoctorType } from "types";
//import { Female, Location, Male, Tag } from "assets/icons";
import SvgGenerator from "components/svgGenerator/SvgGenerator";
import strings from "assets/strings";
import Text from "components/text/Text";
import mergedSettings from "assets/mergeSettings";

interface MashlimDoctorResultProps {
  hit: MashlimDoctorType;
  tabIndex?: number;
}

export const MashlimDoctorResult = forwardRef<HTMLDivElement, MashlimDoctorResultProps>(
  ({ hit, tabIndex }, ref) => {
  const onNavigate = (hit: MashlimDoctorType) => {
    const { /*_geoloc,*/ medicalCenter } = hit;
    //const { lat, lng } = _geoloc || {};
    const address = `${medicalCenter.street || ''} ${medicalCenter.houseNumber || ''} ${medicalCenter.city || ''}`;
    const encodedAddress = encodeURIComponent(address);
    const mobileUrl = `geo://0,0?q=${encodedAddress}`;
    const iosUrl = `maps://?q=${encodedAddress}`;
    const desktopUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    function isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    function isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
    const url = isMobile() ? (isIOS() ? iosUrl : mobileUrl) : desktopUrl;
    window.open(url, "_blank");
  };
  return (
    <div ref={ref} tabIndex={tabIndex}>
      <div className={styles.hitDoctor}>
        <div className={styles.section2}>
          {hit.gender === "נ" ? (
            // <Female className={styles.avatar} />
            <SvgGenerator name="Female" className={styles.avatar} objectName="doctorSearchResults" />
          ) : (
            // <Male className={styles.avatar} />
            <SvgGenerator name="Male" className={styles.avatar} objectName="doctorSearchResults" />
          )}
          <div className={styles.divText}>
            <Text
              className={styles.textGray}
              text={hit.externalDoctorType === 1 ? strings.doctorSearchResults.doctorArrange : strings.doctorSearchResults.doctorRefund}
            />
            <a
              href={`${hit.objectType === 'Doctor'
                ? mergedSettings.doctorPage
                : (hit.objectType === 'Diet'
                  ? mergedSettings.dietPage
                  : mergedSettings.socialWorkerPage)
                }${hit.licenseId ? `?licenseId=${hit.licenseId}` : ''
                }${hit.medicalFieldFieldCode ? `${hit.licenseId ? '&' : '?'}code=${hit.medicalFieldFieldCode}` : ''
                }${hit.doctorIdentity ? `${hit.licenseId ? '&' : '?'}did=${hit.doctorIdentity}` : ''
                }${hit.externalDoctorType ? `${hit.licenseId || hit.medicalFieldFieldCode ? '&' : '?'}doctorType=${hit.externalDoctorType}` : ''
                }`}
              className={styles.textTitle}
            >
              {`${hit.title} ${hit.firstName} ${hit.lastName}`}
            </a>
            <Text className={styles.textPurple} text={hit.medicalFieldName} />
            <Text
              className={styles.text}
              text={`${strings.doctorSearchResults.licenseNum} ${hit.licenseId}`}
            />
          </div>
        </div>

        {/* <div className={styles.section}>
          <div className={styles.divText}>
            <Text className={styles.textTitle2} text={strings.doctorSearchResults.role} />
            <Text
              className={styles.textAddress}
              text={hit.Type}
            />
          </div>
        </div> */}
        {hit.medicalCenter.city && <div className={styles.section}>
          <div className={styles.divText}>
            <Text
              className={styles.textTitle2}
              text={strings.globalStrings.address}
            />
            <span
              id={`navigateToAddress_${hit.objectID}`}
              className={styles.textAddress}>{`${hit.medicalCenter.city}${hit.medicalCenter.street ? ',' : ''} ${hit.medicalCenter.street} ${hit.medicalCenter.houseNumber}`}
            </span>
            {hit._geoloc &&
              <span onClick={() => onNavigate(hit)} className={styles.span} aria-describedby={`navigateToAddress_${hit.objectID}`} tabIndex={0} role="link">
                {/* <Location className={styles.icon} /> */}
                <SvgGenerator name="Location" className={styles.icon} objectName="doctorSearchResults" />
                <Text
                  className={styles.textNavigate}
                  text={strings.doctorSearchResults.navigateToAddress}
                />
              </span>
            }
          </div>

        </div>
        }
        <div className={styles.section3}>
          <div className={styles.divText2}>
            <Text
              className={styles.text}
              text={strings.doctorSearchResults.callToOrder}
            />
            {hit.medicalCenter.phone1 && (
              <Text
                className={styles.textBold}
                text={hit.medicalCenter.phone1}
              />
            )}
            {hit.medicalCenter.phone2 && (
              <Text
                className={styles.textBold}
                text={hit.medicalCenter.phone2}
              />
            )}
          </div>
        </div>
      </div>
      {hit.externalDoctorType === 1 && (
        <div className={styles.divBottom}>
          {/* <Tag className={styles.icon} /> */}
          <SvgGenerator name="Tag" className={styles.icon} objectName="doctorSearchResults" />
          <Text
            className={styles.text}
            text={`${strings.doctorSearchResults.selfPay1} ${hit.paymentSum} ${strings.doctorSearchResults.selfPay2}`}
          />
        </div>
      )}
    </div>
  );
});
